// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"057699f6","796":"014c34fa"}[chunkId] + ".chunk.js";
};